import { styled } from 'styled-components';

import { colors, gutterWidth, spacing } from '#/theme/theme';

export const MobileSearchMenuHolder = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
  background-color: ${colors.white};
  z-index: 104;
  display: flex;
  flex-direction: column;
`;

export const MobileSearchMenuHeader = styled.header`
  align-items: center;
  background: ${colors.white};
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 0 ${gutterWidth / 2}px;
  height: 60px;
  width: 100%;
  border-bottom: 1px solid ${colors.selectionGrey};
`;

export const MobileSearchMenuBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 36px ${gutterWidth / 2}px;
`;

export const MobileSearchMenuForm = styled.form<{
  $isTabbing?: boolean;
}>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  padding: 0;
  font-size: 18px;
`;

export const MobileSearchMenuFooter = styled.footer`
  display: flex;
  align-items: center;
  gap: ${spacing[8]};
  justify-content: center;
  height: 66px;
  box-shadow: 0 -3px 4px 1px rgba(0, 0, 0, 0.15);
`;
